import { render, staticRenderFns } from "./VAssetTypeForm.vue?vue&type=template&id=82d388c6&"
import script from "./VAssetTypeForm.vue?vue&type=script&lang=js&"
export * from "./VAssetTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports